import useHjelpetekst from './useHjelpetekst';
import useHjelpetekstById from './useHjelpetekstById';
/**
 * Sjekker om det finnes tekst til hjelpeskuff for en gitt tjeneste og eventuell hjelpetekstId
 * @param tjenesteNavn Navn på tjenesten
 * @param hjelpetekstId Id til hjelpeteksten
 * @returns true dersom hjelpeteksten finnes og har tittel og tekst, false ellers
 */
const useHasHjelpeskuff = (tjenesteNavn, hjelpetekstId) => {
    const { hjelpeskuffTittel, hjelpeskuffTekst } = useHjelpetekst(tjenesteNavn);
    const { hjelpetekst: hjelpetekstById } = useHjelpetekstById(tjenesteNavn, hjelpetekstId ?? '');
    if (hjelpetekstId) {
        return !!hjelpetekstById?.hjelpeskuffTittel && !!hjelpetekstById?.hjelpeskuffTekst;
    }
    return !!hjelpeskuffTittel && !!hjelpeskuffTekst;
};
export default useHasHjelpeskuff;
